// extracted by mini-css-extract-plugin
export default {"menuContainer":"menu_menuContainer__URHuU","menuItem":"menu_menuItem__xj-c9"};